import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { Selector } from "../Selector/index.js";
import { SynchronizeLanguage } from "./SynchronizeLanguage.js";
function LanguageSelector({
  entry,
  locale,
  moduleSettings
}) {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(SynchronizeLanguage, {}),
    /* @__PURE__ */ jsx(
      Selector,
      {
        entry,
        hideTitle: true,
        locale,
        moduleSettings
      }
    )
  ] });
}
export {
  LanguageSelector
};
